(function ( $ ) {
    (function () {
        $('.show-add-review-form').click(function(e) {
            e.preventDefault();
            let product_id = $(this).data('productId')
            $('html').addClass('open-frame');
            $('.popup-frame').css("display", "flex").hide().fadeIn();
            $('#add-review-form').fadeIn();
            $('#add-review-form [name=\'product_id\']').val(product_id);
        });

        $("#add-review-form").submit(function (e) {
            e.preventDefault()
            let name = $(this).find("[name=\"name\"]").val();
            let contact = $(this).find("[name=\"contact\"]").val();
            let review = $(this).find("[name=\"review\"]").val();
            let product_id = $(this).find("[name=\"product_id\"]").val();
            let token = $('meta[name="csrf-token"]').attr('content');
            let pathArray = window.location.pathname.split('/');

            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find("input[type='submit']").prop('disabled', true);

            axios
                .post(`/ajax/add-product-review`, {
                    name: name,
                    contact: contact,
                    review: review,
                    product_id: product_id,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(resp => {
                    $(this).find("[name=\"name\"]").val("");
                    $(this).find("[name=\"contact\"]").val("");
                    $(this).find("[name=\"review\"]").val("");
                    $('.popup-frame').fadeOut();
                    $('.js-popup').fadeOut();
                    $('html').removeClass('open-frame');

                    $('html').addClass('open-frame');
                    $('.popup-frame').css("display", "flex").hide().fadeIn();
                    $('#success-review').fadeIn();
                })
                .catch(error => {

                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        });
    }());
}( jQuery ));
